// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState } from 'react';
import S from './styles';

interface TextBoxInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | undefined;
  touched?: boolean | undefined;
  errorAuth?: boolean;
  textBoxName: string;
}

const TextBoxInput = (props: TextBoxInputProps): JSX.Element => {
  const { error, touched, value, errorAuth } = props;
  return (
    <>
      <S.Container error={(!!error && !!touched && !!error)} isFilled={!!props.value }>
        {!!props.value && !errorAuth && <S.Label error={!!error && !!touched && !!error}>
          {props.textBoxName}
        </S.Label>}
        <S.Input type={'text'} {...props} />
      </S.Container>
      <S.ErrorMessage>{error && touched && error}</S.ErrorMessage>
    </>
  );
}

export { TextBoxInput as default }
